import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import {
  convertTo12HourFormat,
  truncateText,
} from "../../../../../helpers/helpers";
import { getAllSellerLiveAuction } from "../../../../../redux/action/liveRoom";
import SellerAsideLoader from "../../../../commanPage/location/SellerAsideLoader";

function LiveAside() {
  const isDastop = useMediaQuery({ query: "(max-width: 1420px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 886px)" });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [numLiveData, setNumLiveData] = useState(3);
  const { profile } = useSelector((state) => state?.profileStore);

  const { sellerLoading, allSellerLiveAuctionData } = useSelector((state) => state.sellerLiveAuctionList)

  const handleViewButton = () => {
    setNumLiveData(allSellerLiveAuctionData?.filteredLiveAuctions?.length);
  };

  useEffect(() => {
    dispatch(getAllSellerLiveAuction(profile?.organization))
  }, [dispatch, profile]);


  return (
    <div
      className={`p-1 border-radius-12 `}
      style={{ backgroundColor: "#edeef5", marginTop: "5px" }}
    >
      <div className={`gap-1 ${isTablet && "grid-column-3"}`}>
        {sellerLoading ? (
          <SellerAsideLoader numLiveData={numLiveData} />
        ) : (
          allSellerLiveAuctionData?.filteredLiveAuctions?.slice(0, numLiveData)?.map((items) => (
            <div
              key={items?.auction?.auctionId}
              className="border-radius-12 white mb-1 pointer"
              style={{
                border: "1px solid #6f2da8",
                padding: "0.5rem 0.8rem",
              }}
              onClick={() => {
                if (items?.auction?.auctionType === "reverseAuctionProduct") {
                  navigate(
                    `/reverse-product-auction/live-room/${items?.auction?._id}/${items?.auction?.catalogue?._id}`
                  )
                } else if (items?.auction?.auctionType === "reverseAuctionService") {
                  navigate(
                    `/reverse-service-auction/live-room/${items?.auction?._id}/${items?.auction?.catalogue?._id}`
                  )
                } else {
                  navigate(
                    `/forward-auction/live-room/${items?.auction?._id}/${items?.auction?.catalogue?._id}`
                  )
                }
              }
              }
            >
              <div className="valign-wrapper space-between">
                <h6 className="cercle-purple-text font-14px">
                  Auction ID:{" "}
                  <span className="black-text font-13px">
                    {truncateText(items?.auction?.auctionId, 13)}
                  </span>
                </h6>
                <button
                  className="button-style white-text cercle-purple valign-wrapper small-text"
                  style={{ padding: isDastop ? "3px 7px" : "3px 10px" }}
                >
                  <span
                    className="material-icons-outlined font-16px"
                    style={{ marginRight: "5px" }}
                  >
                    sensors
                  </span>
                  Live
                </button>
              </div>
              <p className="small-text NoOfline" style={{ WebkitLineClamp: 2 }}>
                {items?.auction?.description || "..."}
              </p>
              <p
                className="flex small-text cercle-purple-text"
                style={{ justifyContent: "end" }}
              >
                Ends in:{" "}
                {convertTo12HourFormat(items?.auction?.auctionSchedule?.endingTime)}
              </p>
            </div>
          ))
        )}
      </div>
      {allSellerLiveAuctionData?.filteredLiveAuctions?.length !== 0 ? (
        <>
          {numLiveData === 3 && allSellerLiveAuctionData?.filteredLiveAuctions?.length > 3 ? (
            <div className="flex justify-center">
              <button
                className="bold font-14px white-text cercle-purple border-radius-12"
                style={{ padding: "7px 10px" }}
                onClick={handleViewButton}
              >
                View More
              </button>
            </div>
          ) : (
            <div className="flex justify-center">
              {allSellerLiveAuctionData?.filteredLiveAuctions?.length > 3 && (
                <button
                  className="bold font-14px white-text cercle-purple border-radius-12 mb-1"
                  style={{ padding: "7px 10px" }}
                  onClick={() => {
                    setNumLiveData(3);
                  }}
                >
                  View Less
                </button>
              )}
            </div>
          )}
        </>
      ) : (
        <div
          className="valign-wrapper justify-center column gap-1"
          style={{ height: "160px" }}
        >
          <img src="/images/noliveImg.png" alt="noliveimage" width="120px" />
          <p>No Live Auctions at the Moment!</p>
        </div>
      )}
    </div>
  );
}

export default LiveAside;
